import React from "react";
import styled from "styled-components";
import { GalleryData } from "../common/types";

const GalleryWrapper = styled.div`
  border-radius: 10px;
  display: flex;
  gap: 4rem;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  width: 100%;
  height: auto;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    background-color: ${({ theme }) => theme.galleryBg};
    border-radius: 10px;

    img,
    video {
      width: 100%;
      max-height: 70vh;
      object-fit: contain;
      border-radius: 10px 10px 0 0;
    }

    @media (min-width: 920px) {
      img,
      video {
        max-height: 85vh;
      }
    }

    p {
      font-weight: 200;
      margin: 0.5rem;
    }
  }
`;

const Gallery: React.FC<GalleryData> = ({ imgData, vidData }) => {
  return (
    <GalleryWrapper>
      {/* Render images */}
      {imgData.map((img) => (
        <div key={img.id}>
          <img src={img.src} alt={img.alt} />
          <p>{img.description}</p>
        </div>
      ))}

      {/* Render videos */}
      {vidData.map((vid) => (
        <div key={vid.id}>
          <video controls>
            <source src={vid.src} type={vid.mimetype} />
            Your browser does not support the video tag.
          </video>
          <p>{vid.description}</p>
        </div>
      ))}
    </GalleryWrapper>
  );
};

export default Gallery;
